// extracted by mini-css-extract-plugin
module.exports = {"layoutBlog":"styles-module--layoutBlog--2kNs1"};